import React from 'react'
import { Link } from 'react-router-dom';

function Futura2() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/Multideck" className="block py-1 pl-4 hover:underline mt-6">Multideck -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO 2</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/futurobig.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO 2</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Compact vertical displays for modern retail.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Step into the future of retail with the new Futuro 2 compact multideck. This innovative addition to the Futuro 2 range stands just 150-170cm tall, bringing an open, airy feel to modern stores and packs a big visual impact into a petite package. See and sell more with excellent product visibility - glass doors and LED lighting create an enticing display. Keep food fresher for longer with high-performance refrigeration and top-rated energy efficiency</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Packaged Cod Fish, Meat and Sushi <span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>

       <p className="text-xl lg:text-2xl opacity-90">Beverages, Packaged Charcuterie and Pastry<span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Packaged Hot Food <span className=' text-red-600'> +65 °C</span></p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glicol | R448 | R449</p>
           <p className="text-xl lg:text-2xl  text-center ">(remote condensing unit models)</p>
           <p className="text-xl lg:text-2xl text-lime-500 text-center">R290</p>
           <p className="text-xl lg:text-2xl  text-center">(integral condensing unit models)</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Great visibility and the best performance in a compact format</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Available in 150 or 170 cm high models, this extension to the popular Futuro 2 range offers the benefits that distinguish the range of vertical displays such as.</div>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl font-thin opacity-90 mt-6">
    Excellent presentation and extended product visibility thanks to the large sloping glass front doors.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Cooling with an optimized air curtain that reduces heat ingress and guarantees an even display temperature.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Large display area for products thanks to the vertical evaporator.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    High-performance, low-noise fans.
  </li>
</ul>

    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>High performance, low energy consumption, visibility and low noise for the best shopping experience.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futo2case.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futo2case1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">For refrigerated food</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>The Futuro 2 compact multidecks are available as refrigerated models suitable for selling packaged products such as meat, charcuterie, fruit & vegetables, dairy products, sushi.... But also for the modern grab and go of beverages, snacks or salads, in city centres, train stations, airports or gyms.</div>
</div>
             </div>

              {/* case 3 */}
              <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">For hot food</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Compact Futuro 2 vertical displays are also available in a heated version suitable for selling hot packaged products, grab-and-go items, and ready-to-eat meals such as roasted chicken, pork sandwiches, lasagna, noodles, soups, etc.</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>The innovative ventilated heating system allows up to 34% energy savings compared to traditional models and ensures a uniform temperature throughout the display</div>

</div>
  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/futo2case2.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/futo2card.jpg",
      text: "Available in 90 and 75 cm wide models to suit the space in your store.",
    },
    {
      img: "images/futo2card1.jpg",
      text: "Sliding front doors for greater energy savings and perfect product visibility.",
    },
    {
      img: "images/futo2card2.jpg",
      text: "Easy front access to the condensing unit for cleaning and maintenance.",
    },
    {
      img: "images/futo2card3.jpg",
      text: "Canopy LED lighting. Optional under-shelf lighting is available, as well as an app for controlling the color and brightness of the lighting via mobile device. Simple and intuitive, the perfect illumination for each product.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


     </div>
    
  
        </div>
      )
    }

export default Futura2